import React from 'react';
import { getDisplayPrice } from '@/lib/priceUtils';

export function PriceDisplay({ product, size = 'md', className = '' }) {
  const { original, discounted, hasDiscount, isFree } = getDisplayPrice(product);

  if (isFree) {
    return (
      <div className={`flex items-baseline gap-2 ${className}`} data-testid="price-display-free">
        <span className={`font-bold font-['Outfit'] text-[#1A9DA5] ${size === 'lg' ? 'text-3xl' : size === 'sm' ? 'text-base' : 'text-2xl'}`}>
          Free!
        </span>
        {original > 0 && <span className={`line-through text-muted-foreground ${size === 'lg' ? 'text-lg' : 'text-sm'}`}>${original}</span>}
      </div>
    );
  }

  if (hasDiscount) {
    return (
      <div className={`flex items-baseline gap-2 ${className}`} data-testid="price-display-discounted">
        <span className={`font-bold font-['Outfit'] text-[#E8735A] ${size === 'lg' ? 'text-3xl' : size === 'sm' ? 'text-base' : 'text-2xl'}`}>
          ${discounted.toFixed(2)}
        </span>
        <span className={`line-through text-muted-foreground ${size === 'lg' ? 'text-lg' : 'text-sm'}`}>${original}</span>
      </div>
    );
  }

  return (
    <span className={`font-bold font-['Outfit'] ${size === 'lg' ? 'text-3xl' : size === 'sm' ? 'text-base' : 'text-2xl'} ${className}`} data-testid="price-display-regular">
      ${original}
    </span>
  );
}

export function PriceButton({ product }) {
  const { isFree } = getDisplayPrice(product);
  if (isFree) return 'Get it for free now!';
  return 'Buy Now';
}
